import React, { useState } from "react";
import Konva from "konva";
import { Group, Path, Rect } from "react-konva";
import { showModalFromKonva } from "frontend/modal/modal-bridge";
import EditTaskModal from "./modal/edit-task-modal";
import { ITaskController } from "../controller";

const SIZE = 22;
const ICON_SIZE = 11;

interface ExpandButtonProps extends Konva.NodeConfig {
  controller: ITaskController;
}

export const ExpandButton = React.memo((props: ExpandButtonProps) => {
  const { controller, ...restProps } = props;
  const [isHovered, setIsHovered] = useState(false);

  function onExpand() {
    controller.reportTaskExpanded();
    showModalFromKonva(EditTaskModal, { controller });
  }

  return (
    <Group
      {...restProps}
      width={SIZE}
      height={SIZE}
      onMouseEnter={(e) => {
        setIsHovered(true);
        const container = e.target.getStage()?.container();
        if (container) container.style.cursor = "pointer";
      }}
      onMouseLeave={(e) => {
        setIsHovered(false);
        const container = e.target.getStage()?.container();
        if (container) container.style.cursor = "inherit";
      }}
      onClick={(e) => {
        e.evt.stopPropagation();
        e.evt.preventDefault();
        onExpand();
      }}
    >
      <Rect cornerRadius={6} width={SIZE} height={SIZE} fill={isHovered ? "#F6F7FB" : "transparent"} listening />
      <Group x={-0.5} y={-0.5}>
        <Path
          x={SIZE / 2 - ICON_SIZE / 2}
          y={SIZE / 2 - ICON_SIZE / 2}
          fill="#1E1E1E"
          data="M10.4995 4.33301V1.5H7.6665C7.39036 1.5 7.1665 1.27614 7.1665 1C7.1665 0.723858 7.39036 0.5 7.6665 0.5H10.9995C11.2757 0.5 11.4995 0.723858 11.4995 1V4.33301C11.4995 4.60915 11.2757 4.83301 10.9995 4.83301C10.7235 4.83283 10.4995 4.60904 10.4995 4.33301Z"
        />
        <Path
          x={SIZE / 2 - ICON_SIZE / 2}
          y={SIZE / 2 - ICON_SIZE / 2}
          fill="#1E1E1E"
          data="M10.6464 0.646514C10.8416 0.451288 11.1582 0.451361 11.3534 0.646514C11.5487 0.841776 11.5487 1.15828 11.3534 1.35355L7.46475 5.24222C7.26949 5.43748 6.95298 5.43748 6.75772 5.24222C6.56257 5.04695 6.56249 4.73041 6.75772 4.53519L10.6464 0.646514Z"
        />
        <Path
          x={SIZE / 2 - ICON_SIZE / 2}
          y={SIZE / 2 - ICON_SIZE / 2}
          fill="#1E1E1E"
          data="M4.53506 6.7576C4.73029 6.56237 5.04682 6.56244 5.2421 6.7576C5.43736 6.95286 5.43736 7.26937 5.2421 7.46463L1.35342 11.3533C1.15816 11.5486 0.841654 11.5486 0.646392 11.3533C0.451239 11.158 0.451166 10.8415 0.646392 10.6463L4.53506 6.7576Z"
        />
        <Path
          x={SIZE / 2 - ICON_SIZE / 2}
          y={SIZE / 2 - ICON_SIZE / 2}
          fill="#1E1E1E"
          data="M0.5 7.66663C0.5 7.39048 0.723858 7.16663 1 7.16663C1.27614 7.16663 1.5 7.39048 1.5 7.66663V10.4996H4.33301C4.60904 10.4996 4.83283 10.7236 4.83301 10.9996C4.83301 11.2758 4.60915 11.4996 4.33301 11.4996H1C0.723858 11.4996 0.5 11.2758 0.5 10.9996V7.66663Z"
        />
      </Group>
    </Group>
  );
});

ExpandButton.displayName = "ExpandButton";
